// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3mmCH","title":"styles_title__3CUkW"};